import Page from 'modules/WgsHowItWorks'

export default Page

